import { RegistrationQuestion } from '../types/RegistrationQuestion';
import { getData } from './apiService'; // Assuming getData is a utility function for API calls

// Fetch all questions
export const getAllQuestions = async (): Promise<RegistrationQuestion[]> => {
  try {
    const response = await getData('/preset-registration-questions/', {});
    return response.data as RegistrationQuestion[];  // Type assertion to ensure it matches the expected type
  } catch (error) {
    console.error('Failed to fetch all questions:', error);
    return [];  // Return an empty array in case of an error
  }
};

// Fetch all questions (all types)
export const getAllQuestionsAll = async (): Promise<RegistrationQuestion[]> => {
  try {
    const response = await getData('/preset-registration-questions/all', {});
    return response.data as RegistrationQuestion[];  // Type assertion to ensure it matches the expected type
  } catch (error) {
    console.error('Failed to fetch all questions:', error);
    return [];  // Return an empty array in case of an error
  }
};

// Fetch all music-related questions
export const getMusicQuestions = async (): Promise<RegistrationQuestion[]> => {
  try {
    const response = await getData('/preset-registration-questions/music', {});
    return response.data as RegistrationQuestion[];  // Type assertion to ensure it matches the expected type
  } catch (error) {
    console.error('Failed to fetch music-related questions:', error);
    return [];  // Return an empty array in case of an error
  }
};

// Fetch all sports-related questions
export const getSportsQuestions = async (): Promise<RegistrationQuestion[]> => {
  try {
    const response = await getData('/preset-registration-questions/sports', {});
    return response.data as RegistrationQuestion[];  // Type assertion to ensure it matches the expected type
  } catch (error) {
    console.error('Failed to fetch sports-related questions:', error);
    return [];  // Return an empty array in case of an error
  }
};
